import React from 'react';
import { NavLink } from 'react-router-dom';
import { useNavigationCssClasses } from '../../hooks';
import './NavLinkButton.scss';
export const NavLinkButton = ({ path = '', children, disabled, collapsed = false, onClick, }) => {
    const { navLinkButtonCss } = useNavigationCssClasses({ collapsed, disabled });
    if (disabled) {
        return (React.createElement("button", { className: navLinkButtonCss, type: "button" }, children));
    }
    if (onClick) {
        return (React.createElement("button", { className: navLinkButtonCss, type: "button", onClick: onClick }, children));
    }
    return (React.createElement(NavLink, { className: navLinkButtonCss, to: path }, children));
};
//# sourceMappingURL=NavLinkButton.js.map